module.exports = __webpack_public_path__ + "static/media/Jump.e1f084b0.mp3";